import { Link, useLocation } from 'react-router-dom'
import { LayoutGrid, Mail, FileEdit, HeartPulse, FlaskConical } from 'lucide-react'

export function MobileNav() {
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <nav className="fixed bottom-0 left-0 right-0 mail-tabbar bg-background/90 backdrop-blur-md border-t border-border z-20 md:hidden">
      <div className="flex justify-around items-center h-14">
        <Link
          to="/"
          className={`flex flex-col items-center gap-1 justify-center px-2 py-2 min-w-0 transition-colors ${
            isActive('/') || isActive('/triage')
              ? 'text-primary'
              : 'text-muted-foreground'
          }`}
        >
          <LayoutGrid className="size-icon-nav" />
          <span className="text-[10px]">Triage</span>
        </Link>

        <Link
          to="/drafts"
          className={`flex flex-col items-center gap-1 justify-center px-2 py-2 min-w-0 transition-colors ${
            isActive('/drafts') ? 'text-primary' : 'text-muted-foreground'
          }`}
        >
          <FileEdit className="size-icon-nav" />
          <span className="text-[10px]">Bozze</span>
        </Link>

        <Link
          to="/emails"
          className={`flex flex-col items-center gap-1 justify-center px-2 py-2 min-w-0 transition-colors ${
            isActive('/emails') ? 'text-primary' : 'text-muted-foreground'
          }`}
        >
          <Mail className="size-icon-nav" />
          <span className="text-[10px]">Email</span>
        </Link>

        <Link
          to="/demo"
          className={`flex flex-col items-center gap-1 justify-center px-2 py-2 min-w-0 transition-colors ${
            location.pathname.startsWith('/demo') ? 'text-primary' : 'text-muted-foreground'
          }`}
        >
          <FlaskConical className="size-icon-nav" />
          <span className="text-[10px]">Demo</span>
        </Link>

        <Link
          to="/system-health"
          className={`flex flex-col items-center gap-1 justify-center px-2 py-2 min-w-0 transition-colors ${
            isActive('/system-health') ? 'text-primary' : 'text-muted-foreground'
          }`}
        >
          <HeartPulse className="size-icon-nav" />
          <span className="text-[10px]">Sistema</span>
        </Link>
      </div>
    </nav>
  )
}
